import { createContext } from 'react';

export const WorkorderAssignmentContext = createContext(null);
